import $ from 'jquery';

const section = $('.lc-svg .lc-section-group');
const arrows = $('.lc-svg .arrows');
const content = $('.lifecycle-content .content');

let deg = 0;

function onDocumentReady() {
	section.on('mouseenter', toggleLifecycle);
	section.on('touchenter', toggleLifecycle);
}

function toggleLifecycle(e) {
	const clicked = $(e.currentTarget);
	const sectionNum = clicked.data('section');
	deg = deg + 180;

	content.removeClass('active');
	$('.lifecycle-content .content[data-section="' + sectionNum + '"]').addClass('active');

	section.attr('class', 'lc-section-group');
	clicked.attr('class', 'lc-section-group active');
	arrows.css({ transform: 'rotate(' + deg + 'deg)' });
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
